import React, { Component } from 'react';
import axios from 'axios';
import CardSocialMedia from '../molecules/CardSocialMedia.jsx'
import SectionLoadingLoader from './SectionLoadingLoader.jsx';

class SectionSocialMediaCards extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataRedSocial: []
        }
    }

    // PETITION IS API REST
    componentDidMount() {
        axios.get("https://raw.githubusercontent.com/eliud-cesar/apis-portfolio/master/social-media-master.json")
            .then(resp => {
                // console.log(resp.data)
                this.setState({
                    dataRedSocial: resp.data
                })
            })
    }


    render() {
        const { dataRedSocial } = this.state
        return (
            <section className="grid-social-media-redes-portfolio">
                {
                    dataRedSocial.length === 0
                    ? < SectionLoadingLoader />
                    : dataRedSocial.map(u => 
                        ( 
                            < CardSocialMedia 
                            title={u.title} 
                            description={u.description} 
                            iconRed={u.iconRed} 
                            linkRed={u.linkRed} 
                            /> 
                        ))
                }
            </section>
        )
    }
}

export default SectionSocialMediaCards;
